import React, { useState, useContext } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Text } from 'components/typography';
import { SearchInput } from 'components/form-elements/inputs/SearchInput';
import { useAllUsers } from 'services/admin/get-all-users';
import { useUserPermissions } from 'services/user/permissions';
import { Brikk } from 'components/Brikk';
import { PageLoader } from 'components/loaders/PageLoader';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import styles from './styles.module.scss';
import { UserItem } from './components/UserItem';

export const UsersList = () => {
  const { setSelectedUser, setIsAddingUser, setService } = useContext(UserAdministrationModalContext);
  const { users, isLoading } = useAllUsers();
  const { checkPermission } = useUserPermissions();

  const [keyword, setKeyword] = useState('');

  const intl = useIntl();

  const sortedUsers = [...users].sort((a, b) => -b.firstName.localeCompare(a.firstName));

  const filteredUsers = !keyword
    ? sortedUsers
    : sortedUsers.filter((user) => `${user.firstName} ${user.lastName}`.toLowerCase().includes(keyword.toLowerCase()));

  if (isLoading) return <PageLoader />;

  return (
    <div className={styles.container}>
      <Brikk.Heading heading="currentUsers" />
      <SearchInput
        placeholder={intl.formatMessage({ id: 'search' })}
        keyword={keyword}
        setKeyword={setKeyword}
      />

      <div className={styles.usersList}>
        {filteredUsers && filteredUsers.length > 0 ? (
          filteredUsers.map((user) => (
            <UserItem
              key={user.id}
              user={user}
            />
          ))
        ) : (
          <Text
            secondary
            center
            intl="noUsersToDisplay"
            size={16}
          />
        )}
      </div>

      {checkPermission('admin-users', 'create') && (
        <Button
          primary
          style={{ width: 'fit-content', marginLeft: 'auto' }}
          onClick={() => {
            setSelectedUser(null);
            setIsAddingUser(true);
            setService(null);
          }}
        >
          <FormattedMessage id="addNewUser" />
        </Button>
      )}
    </div>
  );
};
